import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CommunityOnboardingModal from "@/components/CommunityOnboardingModal";

export default function Layout({ children }) {
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
      <CommunityOnboardingModal />
    </div>
  );
}
